import React, { useState  } from 'react'
import configData from "../appconfig/config.json";
import { FormInput, FormComboBox, FormNumericTextBox } from '../core/customComponents';
import { acntNameValidator, tovalidateExpdate, nominatedbankVaild, bankAcntNOValidator, AmountValidator, tenureValidator } from '../core/validationRules';
import FormContainer from './FormContainer';
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import toFetchIDValue from '../data/IdTypeCheck';

import banklist from '../data/banklist';
import tenure from '../data/tenure';
import { Button } from '@progress/kendo-react-buttons';

var CryptoJS = require("crypto-js");
let key = CryptoJS.enc.Utf8.parse("8080808080808080");
let iv = CryptoJS.enc.Utf8.parse("8080808080808080");

class LoanCalculator extends React.Component {
    constructor(props) {
        super(props);
        configData.RefferenceNo = localStorage.getItem('Ref');
        this.onHandleLoanAmountChange = this.onHandleLoanAmountChange.bind(this);
        
        configData.CrediAbleAcntNo = localStorage.getItem('RefCA');
        this.state = {
            loanTenure: "",
            loanAmount: '',
            nominatedFullName: "",
            nominatedbankAcntNo: "",
            nominatedBank: "",
            monthlyRepayment: "",
            monthlyRepayment: "0.00",
            setTotalRepayment: "0.00",
            effIntstRateVal: "",
            intstRateVal: "",
            responseObj: {}
        }


    }

    getRatesByTenure = (selectedTenure) => {
        const srcParm = localStorage.getItem('srcParm') || '';
        const defaultRatesByTenure = {
            [configData.TENURE1]: { int: configData.INT_RATE1, eft: configData.EFT_RATE1 },
            [configData.TENURE2]: { int: configData.INT_RATE2, eft: configData.EFT_RATE2 },
            [configData.TENURE3]: { int: configData.INT_RATE3, eft: configData.EFT_RATE3 },
            [configData.TENURE4]: { int: configData.INT_RATE4, eft: configData.EFT_RATE4 },
            [configData.TENURE5]: { int: configData.INT_RATE5, eft: configData.EFT_RATE5 }
        };

        const newRatesByTenure = {
            [configData.TENURE1]: { int: configData.INT_RATE1new, eft: configData.EFT_RATE1new },
            [configData.TENURE2]: { int: configData.INT_RATE2new, eft: configData.EFT_RATE2new },
            [configData.TENURE3]: { int: configData.INT_RATE3new, eft: configData.EFT_RATE3new },
            [configData.TENURE4]: { int: configData.INT_RATE4new, eft: configData.EFT_RATE4new },
            [configData.TENURE5]: { int: configData.INT_RATE5new, eft: configData.EFT_RATE5new }
        };

        const fc08RatesByTenure = {
            [configData.TENURE1]: { int: configData.INT_RATE1FC08, eft: configData.EFT_RATE1FC08 },
            [configData.TENURE2]: { int: configData.INT_RATE2FC08, eft: configData.EFT_RATE2FC08 },
            [configData.TENURE3]: { int: configData.INT_RATE3, eft: configData.EFT_RATE3 },
            [configData.TENURE4]: { int: configData.INT_RATE4, eft: configData.EFT_RATE4 },
            [configData.TENURE5]: { int: configData.INT_RATE5, eft: configData.EFT_RATE5 }
        };

        let selectedRateConfig = defaultRatesByTenure[selectedTenure];

        if (srcParm === '' || srcParm === 'FC06' || srcParm === 'FC07') {
            selectedRateConfig = newRatesByTenure[selectedTenure] || selectedRateConfig;
        } else if (srcParm === 'FC08') {
            selectedRateConfig = fc08RatesByTenure[selectedTenure] || selectedRateConfig;
        }

        if (!selectedRateConfig) {
            return {
                effIntstRateVal: "",
                intstRateVal: ""
            };
        }

        return {
            effIntstRateVal: selectedRateConfig.int + " %  p.a.",
            intstRateVal: selectedRateConfig.eft + " %  p.a."
        };
    }

    updateRatesForTenure = (selectedTenure) => {
        const { effIntstRateVal, intstRateVal } = this.getRatesByTenure(selectedTenure);
        this.setState({ effIntstRateVal, intstRateVal });
    }

    componentDidMount() {
        // Run once immediately when page loads
        this.updateRatesForTenure(this.state.loanTenure);

        if (tovalidateExpdate(new Date().getMinutes())) {
            if (configData.RefferenceNo) {

                const requestBody = {
                    referenceno: configData.RefferenceNo,
                    num: localStorage.getItem('nricval')
                }

                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Access-Control-Allow-Headers': 'Content-Type',
                        'Cache-Control': 'no-cache',//for IE issues
                        'Pragma': 'no-cache',
                        'Authorization': "Maybank" + " " + localStorage.getItem('tkn')
                    },
                    body: JSON.stringify(requestBody)

                };

                fetch(configData.GET_FTDATA, requestOptions)

                    .then(async response => {

                        const data = await response.json();
                        if (!data.didError) {
                            if (data.model.fields) {
                                if (data.model.fields.Fields) {
                                    let res = data.model.fields.Fields.TL;
                                    await this.setState({ loanTenure: res.loanTenure }, () => {
                                        // Recalculate once tenure is hydrated from API
                                        this.updateRatesForTenure(this.state.loanTenure);
                                    });
                                    await this.setState({ loanAmount: res.loanAmount });
                                    await this.setState({ nominatedFullName: res.nominatedFullName });
                                    await this.setState({ nominatedBank: res.nominatedBank });
                                    await this.setState({ nominatedbankAcntNo: res.nominatedbankAcntNo });
                                    window.scrollTo(0, 0);
                                }
                            }

                        } else {

                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
            } else {
                alert("This session has timed out for your security.");
                document.location.href = configData.URL_ToHomeScreen;
                localStorage.clear();
                return false;
            }
        } else {
            alert("This session has timed out for your security.");
            window.location.href = configData.URL_ToHomeScreen
            localStorage.clear();
            return false;
        }


    }


    handleSubmit = (event) => {

        if (localStorage.getItem('mbl')) {
            configData.decryptMbl = CryptoJS.AES.decrypt(localStorage.getItem('mbl'), key, { iv: iv })
            configData.decryptMbl = configData.decryptMbl.toString(CryptoJS.enc.Utf8)
        } else {
            configData.decryptMbl = localStorage.getItem('mbl');
        }

        const effIntstRateVal = this.state.effIntstRateVal;
        const intstRateVal = this.state.intstRateVal;


        const requestBody = {
            TL: {
                fullName: localStorage.getItem('Otp_Name'),//from personal info//to do change to gloabl
                NRICVVal: localStorage.getItem('Otp_nric'),//from personal info//to do change to gloabl
                mobileNo: configData.decryptMbl,//from personal info//to do change to gloabl
                loanAmount: event.values.loanAmount,
                loanTenure: event.values.loanTenure,
                creditAbleAcntNo: configData.CrediAbleAcntNo,//11 digit Acnt No

                nominatedFullName: event.values.nominatedFullName,
                nominatedBank: event.values.nominatedBank,
                nominatedBankID: toFetchIDValue("BANKDATALIST", event.values.nominatedBank),
                nominatedbankAcntNo: event.values.nominatedbankAcntNo,

                interestRate: effIntstRateVal,
                effectiveIntRate: intstRateVal,
                SOURCE_CODE: localStorage.getItem('Otp_Sc'),
                domain_URI: localStorage.getItem('domainURI')

            }
        }

        

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Cache-Control': 'no-cache',//for IE issues
                'Pragma': 'no-cache',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Authorization': "Maybank" + " " + localStorage.getItem('tkn')
            },
            body: JSON.stringify(requestBody)

        };

        fetch(configData.URL_SAVE_FT + "?refno=" + configData.RefferenceNo + "&prodtype=" + configData.PRODUCT_TYPE, requestOptions)
            .then(async response => {

                const data = await response.json();

                if (!data.didError) {
                    this.props.history.push('ReviewDetails');
                    window.scrollTo(0, 0);
                } else {
                    alert("Some thing went wrong! please try again")
                }

                // history.push('ReviewDetails')

            })
            .catch(error => {
                alert("Some thing went wrong! please try again");
                document.location.href = configData.URL_ToHomeScreen;
                console.error('There is an error!', error);


            });



    }


    onHandleLoanAmountChange = async (e) => {


    }

    // loanAmount = async (event) => {
    //     console.log(event.target.value);
    //     this.state.loanTenure = "";
    //     this.state.monthlyRepayment = "";
    //     this.state.setTotalRepayment = "";
    //     await this.setState({ loanAmount: event.target.value });

    // }

    loanTenure = async (event) => {
        const selectedTenure =
            (event && event.target && event.target.value) ||
            (event && event.value) ||
            "";

        await this.setState({ loanTenure: selectedTenure });
        this.updateRatesForTenure(selectedTenure);

    }
    // loanTenure = async (event) => {

    //     if (this.state.loanAmount) {
    //         if (this.state.loanAmount >= 2000) {
    //             let lT;
    //             let IR;
    //             if (event.target.value === configData.TENURE1) {
    //                 lT = configData.LT1;
    //                 IR = configData.INT_RATE1;
    //             }
    //             if (event.target.value === configData.TENURE2) {
    //                 lT = configData.LT2;
    //                 IR = configData.INT_RATE2;
    //             }
    //             if (event.target.value === configData.TENURE3) {
    //                 lT = configData.LT3;
    //                 IR = configData.INT_RATE3;
    //             }
    //             if (event.target.value === configData.TENURE4) {
    //                 lT = configData.LT4;
    //                 IR = configData.INT_RATE4;
    //             }

    //             if (event.target.value === configData.TENURE5) {
    //                 lT = configData.LT5;
    //                 IR = configData.INT_RATE5;

    //             }

    //             let mul = this.state.loanAmount * (IR / 100);
    //             let first = (mul * lT / 12);//LT

    //             let add = ((+first) + (+this.state.loanAmount));
    //             let result = (add / lT).toFixed(2);//LT
    //             this.state.monthlyRepayment = result;
    //             let setprocessingPayment = (this.state.loanAmount * (2 / 100))
    //             let setTotalRepayment = result * lT
    //             this.state.setTotalRepayment = setTotalRepayment.toFixed(2);

    //         } else {
    //             this.state.loanTenure = "";
    //             this.state.monthlyRepayment = "";
    //             this.state.setTotalRepayment = "";
    //             console.log('The amount transferred cannot be less than S$2000');
    //         }


    //     }
    //     console.log(event.target.value);
    //     await this.setState({ loanTenure: event.target.value });

    //     if (!event.target.value) {
    //         this.state.monthlyRepayment = "";
    //         this.state.setTotalRepayment = "";
    //     }
    // }

    render() {
        const interestRateDisplay = (this.state.effIntstRateVal || '').replace(' %  p.a.', '');
        const effectiveInterestRateDisplay = (this.state.intstRateVal || '').replace(' %  p.a.', '');

        return (
            <div className="container-fluid">

                <div className='row'>
                    <div className="container mt-5">
                        <h2 className="welcome mb-0">{configData.APP_NAME}</h2>
                    </div>


                    <div className="demo-section k-content dynmicwhitecntr  DynamicFields">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="row example-wrapper">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div className="card-block">

                                        <Form
                                            initialValues={this.state}
                                            key={JSON.stringify(this.state)}
                                            onSubmitClick={this.handleSubmit}
                                            render={(formRenderProps) => (
                                                <FormElement>

                                                    <fieldset className={'k-form-fieldset'}>
                                                        <div className="row around-xs inputPairelementVisible" style={{ marginTop: "1.5rem" }}>
                                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                                {/* <legend className={'k-form-legend'}>{configData.HDR_LC_DETAILS}</legend> */}
                                                            </div>
                                                        </div>

                                                    </fieldset>
                                                    <h2>Application Details</h2>

                                                    <fieldset>
                                                        <p>Note: Maximum approved loan amount will be at 80% of the available credit limit during time of processing.</p>
                                                        
                                                        {(localStorage.getItem('srcParm') == 'FC02') && (
                                                            <p><b>
                                                            *For a limited period, be rewarded with an automatic Arbutus timepiece worth S$450 with a minimum loan of S$7,000 and tenure of 24 months or more. T&Cs apply.* 
                                                            </b>
                                                            </p>
                                                        )}
                                                        
                                                        {(localStorage.getItem('srcParm') == 'FC06') && (
                                                            <p><b>
                                                            *For a limited period, enjoy up to 2% cashback with a minimum loan of S$10,000 and tenure of 36 months or more. T&Cs apply.* 
                                                            </b>
                                                            </p>
                                                        )}

                                                        {/* <p>Calculate your estimated monthly repayment based on your preferred loan amount and tenure.</p> */}
                                                    </fieldset>
                                                    <Field
                                                        id={"loanAmount"}
                                                        name={'loanAmount'}
                                                        label={'Loan Amount (S$)'}
                                                        placeholder={"Minimum S$ 1000"}
                                                        component={FormInput}
                                                        onChange={this.onHandleLoanAmountChange}
                                                        // onChange={this.loanAmount}
                                                        validator={AmountValidator}
                                                    />







                                                    <Field

                                                        label={'Loan Repayment Period'}
                                                        component={FormComboBox}

                                                        key={'loanTenure'}
                                                        id={'loanTenure'}
                                                        name={'loanTenure'}
                                                        placeholder={'Please Select'}
                                                        onChange={this.loanTenure}
                                                        data={tenure}
                                                        validator={tenureValidator}
                                                        value={this.state.loanTenure}
                                                    />



                                                    <br></br>
                                                    {/* 
    <div className="row around-xs inputPair elementVisible">
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div className="box"><label className="k-label">
                Loan Amount (S$)</label>
                <br></br>
                <div className="k-form-field-wrap">
                    <input style={{ width: "100 %", padding: "7px" }}

                        placeholder={"Minimum S$ 2000"}
                        type={"number"}
                        id={"loanAmount"} name={'loanAmount'}
                        onChange={this.loanAmount}
                        validator={this.requiredValidator}
                    />
                </div>
            </div>
        </div>

        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">

            <div className="box"><label className="k-label">
                Loan Repayment Period</label>
                <br></br>
                <div className="k-form-field-wrap">
                    <ComboBox
                        key={'loanTenure'}
                        id={'loanTenure'}
                        name={'loanTenure'}
                        placeholder={'Please Select'}
                        onChange={this.loanTenure}
                        data={tenure}
                        validator={requiredValidator}
                        value={this.state.loanTenure}
                    />
                </div>
            </div>
        </div>
    </div>
*/}

                                                    <legend className={'k-form-legend'}></legend>

                                                    <fieldset>
                                                        {/* <PayBillsView /> */}
                                                        <div className="row around-xs inputPair elementVisible">
                                                            <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                                                                <div className="box">
                                                                    {/* <label   className="k-label">
                    Monthly repayment</label>
                    <br></br>
                    <div className="k-form-field-wrap">
                        <label   className="k-label" >
                            <span className="smallContent">{configData.SING_DOLR}</span>
                            <p className="lrgContent"> {this.state.monthlyRepayment}</p></label>
                    </div>*/}
                                                                </div>
                                                            </div>

                        <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">

                            <div className="box"><label className="k-label">
                                Interest Rate</label>
                                <br></br>
                                <div className="k-form-field-wrap">

                                    {(this.state.loanTenure === configData.TENURE1) && <label className="k-label" >
                                        
                                        <p className="lrgContent"> {interestRateDisplay}</p>

                                        <span className="smallContent">{configData.P_A}</span>
                                    </label>}
                                    {(this.state.loanTenure === configData.TENURE2) && <label className="k-label" >

                                        <p className="lrgContent"> {interestRateDisplay}</p>
                                        <span className="smallContent">{configData.P_A}</span>
                                    </label>}
                                    {(this.state.loanTenure === configData.TENURE3) && <label className="k-label" >

                                        
                                        <p className="lrgContent"> {interestRateDisplay}</p>
                                        <span className="smallContent">{configData.P_A}</span>
                                    </label>}
                                    {(this.state.loanTenure === configData.TENURE4) && <label className="k-label" >

                                        <p className="lrgContent"> {interestRateDisplay}</p>
                                        <span className="smallContent">{configData.P_A}</span>
                                    </label>}
                                    {(this.state.loanTenure === configData.TENURE5) && <label className="k-label" >

                                        <p className="lrgContent"> {interestRateDisplay}</p>

                                        <span className="smallContent">{configData.P_A}</span>
                                    </label>}


                                </div>
                            </div>
                        </div>
                    </div>



                                                        <div className="row around-xs inputPair elementVisible">
                                                            <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                                                                {/* <div className="box"><label   className="k-label">
                    Total repayment</label>
                    <br></br>
                    <div className="k-form-field-wrap">
                        <label   className="k-label" >
                            <span className="smallContent">{configData.SING_DOLR}</span>
                            <p className="lrgContent"> {this.state.setTotalRepayment}</p></label>
                    </div>
                </div> */}
                                                            </div>

                                                            <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">

                                                                <div className="box"><label className="k-label">
                                                                    Effective Interest Rate</label>
                                                                    <br></br>
                                                                    <div className="k-form-field-wrap">
                                                                        {(this.state.loanTenure === configData.TENURE1) && <label className="k-label" >

                                                                            <p className="lrgContent"> {effectiveInterestRateDisplay}</p>

                                                                            <span className="smallContent">{configData.P_A}</span>
                                                                        </label>}
                                                                        {(this.state.loanTenure === configData.TENURE2) && <label className="k-label" >

                                                                            <p className="lrgContent"> {effectiveInterestRateDisplay}</p>

                                                                            <span className="smallContent">{configData.P_A}</span>
                                                                        </label>}
                                                                        {(this.state.loanTenure === configData.TENURE3) && <label className="k-label" >

                                                                            <p className="lrgContent"> {effectiveInterestRateDisplay}</p>


                                                                            <span className="smallContent">{configData.P_A}</span>
                                                                        </label>}
                                                                        {(this.state.loanTenure === configData.TENURE4) && <label className="k-label" >

                                                                            <p className="lrgContent"> {effectiveInterestRateDisplay}</p>

                                                                            <span className="smallContent">{configData.P_A}</span>
                                                                        </label>}
                                                                        {(this.state.loanTenure === configData.TENURE5) && <label className="k-label" >

                                                                            <p className="lrgContent"> {effectiveInterestRateDisplay}</p>

                                                                            <span className="smallContent">{configData.P_A}</span>
                                                                        </label>}


                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>




                                                    </fieldset>
                                                    <br></br><br></br>
                                                    <h2>Nominated Bank Details</h2>
                                                    <fieldset className={'k-form-fieldset'}>
                                                        <div className="row around-xs inputPairelementVisible">
                                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                                <legend className={'k-form-legend'}>{"Maybank FlexiCash Application"}</legend>
                                                            </div>
                                                        </div>
                                                    </fieldset>






                                                    <Field id={'nominatedFullName'}
                                                        name={'nominatedFullName'}
                                                        label={'Name as per your Nominated Bank Account (belonging to Principal Cardmember)'}
                                                        placeholder={'Full Name in NRIC/Passport'}
                                                        component={FormInput}
                                                        validator={acntNameValidator}
                                                    />
                                                    <Field
                                                        key={'nominatedBank'}
                                                        id={'nominatedBank'}
                                                        name={'nominatedBank'}
                                                        label={'Nominated Bank (Please specify a non-Maybank Account)'}
                                                        component={FormComboBox}
                                                        data={banklist}
                                                        value={this.state.selectedBank}
                                                        validator={nominatedbankVaild}

                                                    />


                                                    <Field id={'nominatedbankAcntNo'} name={'nominatedbankAcntNo'} label={'Nominated Bank Account No.'} placeholder={'Please fill Bank Account No.'} component={FormInput} validator={bankAcntNOValidator} />
                                                    <div className="text-right" style={{ marginTop: "2rem" }}>
                                                        <Button className="btnMaybank"
                                                            primary={true}
                                                            type={'submit'}
                                                            disabled={!formRenderProps.valid}>{configData.ON_NEXT}</Button>

                                                    </div>

                                                    <br></br>


                                                </FormElement>
                                            )} /></div></div></div></div></div>


                </div>
            </div>
        )
    }
}


export default LoanCalculator;

